import { z } from "zod";

//DiarioObrasEquipamentoSchema

const optionalNumber = z.coerce.number().int().nullable().optional();
const optionalString = z.coerce.string().trim().nullable().optional().transform(e => e === '' ? null : e);

export const DiarioObrasEquipamentoSchema = z.object({
  IdDiarioObrasEquipamento: z.number().int().default(0),
  IdDiarioObras: optionalNumber,
  IdMaquinaEquip: optionalNumber,
  Descricao: optionalString.pipe(z.string().max(250, "Máximo de 250 caracteres").nullable().optional()),
  Tipo: z.coerce.string().max(1).nullable().optional(),
  Quantidade: z.coerce.number().int().min(1, "A quantidade deve ser maior que 0").nullable().optional(),
});

// DiarioObrasEfetivoForm
export type DiarioObrasEquipamentoForm = z.infer<typeof DiarioObrasEquipamentoSchema>;